import React, { useState } from 'react';
import ProgressSteps from '../components/ToolBox/ProgressSteps';
import Step1_Input from '../components/ToolBox/DoctorServiceUpdater/Step1_Input';
import Step2_Map from '../components/ToolBox/DoctorServiceUpdater/Step2_Map';
import Step3_Preview from '../components/ToolBox/DoctorServiceUpdater/Step3_Preview';
import Step4_Confirm from '../components/ToolBox/DoctorServiceUpdater/Step4_Confirm';
import Step5_Complete from '../components/ToolBox/DoctorServiceUpdater/Step5_Complete';

const DoctorServiceUpdater = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [clinicId, setClinicId] = useState('');
  const [inputData, setInputData] = useState(null);
  const [mappingData, setMappingData] = useState(null);
  const [previewData, setPreviewData] = useState(null);
  const [summary, setSummary] = useState(null);
  const [error, setError] = useState('');

  const handleStep1Next = (data) => {
    setInputData(data);
    setClinicId(data.clinicId);
    setError('');
    setCurrentStep(1);
  };

  const handleStep2Next = (data) => {
    setMappingData(data);
    setError('');
    setCurrentStep(2);
  };

  const handleStep3Next = (data) => {
    setPreviewData(data);
    setError('');
    setCurrentStep(3);
  };

  const handleStep4Complete = (data) => {
    setSummary(data);
    setError('');
    setCurrentStep(4);
  };

  const handleRestart = () => {
    setCurrentStep(0);
    setInputData(null);
    setMappingData(null);
    setPreviewData(null);
    setSummary(null);
    setError('');
  };

  const goToStep = (step) => {
    setCurrentStep(step);
    setError('');
  };

  return (
    <div className="max-w-6xl mx-auto p-6">
      <div className="bg-white rounded-lg shadow-lg p-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Doctor Service Updater</h1>
          <p className="text-gray-600">
            Update service_provided for doctors. Provide doctor_name and services, map to clinic doctors, then apply.
          </p>
        </div>

        <ProgressSteps currentStep={currentStep} totalSteps={5} />

        {currentStep === 0 && (
          <Step1_Input
            onNext={handleStep1Next}
            loading={false}
            error={error}
            setError={setError}
          />
        )}

        {currentStep === 1 && inputData && (
          <Step2_Map
            clinicId={inputData.clinicId}
            items={inputData.items}
            onBack={() => goToStep(0)}
            onNext={handleStep2Next}
            error={error}
            setError={setError}
          />
        )}

        {currentStep === 2 && mappingData && (
          <Step3_Preview
            clinicId={mappingData.clinicId}
            mappings={mappingData.mappings}
            onBack={() => goToStep(1)}
            onNext={handleStep3Next}
            error={error}
            setError={setError}
          />
        )}

        {currentStep === 3 && previewData && (
          <Step4_Confirm
            clinicId={previewData.clinicId}
            mappings={previewData.mappings}
            onBack={() => goToStep(2)}
            onComplete={handleStep4Complete}
            error={error}
            setError={setError}
          />
        )}

        {currentStep === 4 && summary && (
          <Step5_Complete summary={summary} onRestart={handleRestart} />
        )}
      </div>
    </div>
  );
};

export default DoctorServiceUpdater;
